module.exports = __webpack_public_path__ + "static/media/joseph.ab661982.jpg";